import * as firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

const config = {
  apiKey: 'AIzaSyAKBNQB_Rfmw5w-1bt_2P2H_hpU19lwMcY',
  authDomain: 'submitify.firebaseapp.com',
  databaseURL: 'https://submitify.firebaseio.com',
  projectId: 'submitify',
  storageBucket: 'submitify.appspot.com',
  messagingSenderId: '1098153405230',
  appId: '1:1098153405230:web:eaaff2acce8e72d983e8bf',
};

firebase.initializeApp(config);

const firestore = firebase.firestore();
const functions = firebase.functions();
let endpoint = '';

if (window.location.hostname === 'localhost') {
  firestore.settings({
    host: 'localhost:5002',
    ssl: false,
  });
  endpoint = 'http://localhost:5000';
  functions.useFunctionsEmulator('http://localhost:5001');
}

const apiEndpoint = `${endpoint}/api`;
const auth = firebase.auth();
const storage = firebase.storage();

export {
  firebase,
  firestore,
  auth,
  storage,
  apiEndpoint,
  functions,
};
